module.exports = __webpack_public_path__ + "static/img/bg-info.ffbb16c0.png";